export default __webpack_public_path__ + "static/media/rank-1.07432223.png";